import src from "IMAGE";
export default { src, width: 1920, height: 741, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAHElEQVR42qXKIQEAAAwCsJX9+0cgAgIxN7hiCx/G8wl6Yu6WGAAAAABJRU5ErkJggg=="};
